import React from 'react'
const ConditionalField = ({
                              condition,
                              children,
                          }: {
    condition: boolean;
    children: React.ReactNode;
}) => {
    return condition ? <>{children}</> : null
}

export default ConditionalField